import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { formatUpcomingTime } from 'helpers/VideoHelper';
import { getDayLabel, getTimeLeft } from '../../../../LiveHelpers';
import Style from './TuneInMeta.module.scss';

const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const TuneInMeta = props => {
  const { tuneIn, retired, startDate } = props;
  const [timeLeftText, setTimeLeftText] = useState(getTimeLeft(startDate));
  useEffect(() => {
    setTimeLeftText(getTimeLeft(startDate));
    const timer = setInterval(() => setTimeLeftText(getTimeLeft(startDate)), 1000);
    return () => clearInterval(timer);
  }, [props, timeLeftText, startDate]);
  const airDate = formatUpcomingTime({ startDate });
  const { seriesDetail_retiredShowTuneInLabel: retiredTuneInLabel } = window.Language;
  let dayLabelText = getDayLabel(startDate);
  if (!dayLabelText) dayLabelText = days[new Date(startDate).getDay()];
  let tuneInText = retired ? tuneIn || retiredTuneInLabel : tuneIn;
  if (!tuneInText) tuneInText = airDate.replace(/-/g, '/');
  const metaText = dayLabelText
    ? `${dayLabelText}, ${tuneInText}${timeLeftText && '  ·  IN '}${timeLeftText}`
    : tuneInText;
  return (
    <span className={Style.meta}>
      <span>{metaText?.toUpperCase() || ''}</span>
    </span>
  );
};

TuneInMeta.propTypes = {
  tuneIn: PropTypes.string,
  retired: PropTypes.bool,
  startDate: PropTypes.string,
};

export default TuneInMeta;
